import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, FileText, Zap, BookOpen, Star } from 'lucide-react';
import { CTAButton } from './Shared';
export const Hero = () => {
  return <div className="relative overflow-hidden pt-12 pb-8 md:pt-20 md:pb-12 bg-transparent" data-id="element-135">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-pink/20 rounded-full blur-[140px] -z-10 pointer-events-none" data-id="element-136"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="space-y-[0px] space-x-[4px] bg-transparent" data-id="element-138">
          <div className="inline-flex bg-white border border-brand-pink/50 px-4 py-1.5 rounded-full mb-4 space-x-2 pt-[0px] pb-[0px] pl-[1px] pr-[1px] flex-row items-center justify-center shadow-sm" data-id="element-139">
            <span className="text-[12px]" data-id="element-140">🌟</span>
            <span className="font-serif font-semibold tracking-wider md:text-base text-[12px] text-brand-text" data-id="element-141">
              LUMEN AKASHA™
            </span>
          </div>

          <h1 className="md:text-6xl lg:text-7xl font-serif font-bold mb-8 text-[18px]" data-id="element-142">
            Todo tu año de Abundancia.
            <br data-id="element-143" />
            <span className="gold-gradient-text text-[24px]" data-id="element-144">
              Listo. Desde hoy.
            </span>
          </h1>

          <div className="mb-8 relative z-10" data-id="element-145">
            <img src="https://cdn.magicpatterns.com/uploads/889QH9FU3YHxfGKttrrHiv/mockup.png" alt="Código de Abundancia Mega Pack" className="w-full max-w-3xl mx-auto drop-shadow-[0_20px_50px_rgba(27,139,90,0.25)] pl-[60px] pr-[60px]" data-id="element-146" />
          </div>

          <div className="max-w-3xl mx-auto mb-8 space-y-3 px-4" data-id="element-147">
            <p className="md:text-xl font-bold text-brand-gold font-[Georgia,_serif] text-[12px]" data-id="element-148">
              El sistema que en los primeros 30 días te muestra exactamente por
              dónde se va tu dinero, cierra las fugas y te da tu primer plan
              real de salida de deudas.
            </p>
            <p className="md:text-base text-brand-text/80 text-[12px] font-[Inter,_sans-serif]" data-id="element-149">
              Sin coaches. Sin cursos de $200 USD. Sin promesas vacías. Solo un
              sistema probado, paso a paso, diseñado para la realidad argentina.
            </p>
          </div>

          <div className="flex flex-wrap md:gap-6 mb-12 text-xs md:text-sm font-medium gap-[12px] items-start justify-center" data-id="element-150">
            <div className="flex bg-white px-4 py-2 rounded-full border border-brand-pink/30 whitespace-nowrap text-[9px] pt-[6px] pb-[6px] pl-[10px] pr-[10px] mt-[0px] ml-[0px] items-start justify-start shadow-sm" data-id="element-151">
              <Zap className="w-4 h-4 mr-2 text-brand-gold shrink-0" data-id="element-152" />
              Acceso en 5 min
            </div>
            <div className="flex items-center bg-white px-4 py-2 rounded-full border border-brand-pink/30 whitespace-nowrap text-[9px] pl-[10px] pr-[10px] ml-[0px] shadow-sm" data-id="element-153">
              <span className="mr-2 text-brand-gold shrink-0" data-id="element-154">🇦🇷</span>
              Para Argentina
            </div>
            <div className="flex items-center bg-white px-4 py-2 rounded-full border border-brand-pink/30 whitespace-nowrap text-[9px] pb-[9px] mb-[10px] shadow-sm" data-id="element-155">
              <BookOpen className="w-4 h-4 mr-2 text-brand-gold shrink-0" data-id="element-156" />6
              Tomos completos
            </div>
          </div>

          <div className="flex flex-col items-center space-y-6" data-id="element-157">
            <CTAButton className="text-xl px-10 py-5" data-id="element-158">
              🌟 → QUIERO MI MEGAPACK AHORA
            </CTAButton>

            <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-brand-muted" data-id="element-159">
              <div className="flex items-center text-[10px]" data-id="element-160">
                <Shield className="w-4 h-4 mr-1.5" data-id="element-161" /> Garantía 7 días
              </div>
              <div className="flex items-center text-[10px]" data-id="element-162">
                <Lock className="w-4 h-4 mr-1.5" data-id="element-163" /> Pago seguro
              </div>
              <div className="flex items-center text-[10px]" data-id="element-164">
                <CreditCard className="w-4 h-4 mr-1.5" data-id="element-165" /> Mercado Pago
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Social Proof Bar */}
      <div className="mt-12 border-y border-brand-pink/20 bg-white/50 py-4 pt-[1px] pb-[1px]" data-id="element-166">
        {/* Mobile: wrapped grid */}
        <div className="md:hidden flex flex-wrap justify-center gap-x-6 gap-y-2 px-4 text-[13px]" data-id="element-167">
          <div className="flex items-center" data-id="element-168">
            <span className="font-bold text-brand-gold mr-1.5" data-id="element-169">+500</span>
            personas que confiaron
          </div>
          <div className="flex items-center" data-id="element-170">
            <span className="font-bold text-brand-gold mr-1.5" data-id="element-171">6</span> Tomos
            listos
          </div>
          <div className="flex items-center" data-id="element-172">
            <span className="font-bold text-brand-gold mr-1.5" data-id="element-173">2</span> Bonus
            incluidos
          </div>
          <div className="flex items-center" data-id="element-174">
            <Star className="w-3.5 h-3.5 text-brand-gold fill-brand-gold mr-1" data-id="element-175" />
            4.9/5 calificación
          </div>
        </div>

        {/* Desktop: horizontal row with dots */}
        <div className="hidden md:flex flex-row items-center space-x-6 justify-center whitespace-nowrap px-4" data-id="element-176">
          <div className="flex items-center text-[15px]" data-id="element-177">
            <span className="font-bold text-brand-gold mr-2" data-id="element-178">+500</span>
            personas que confiaron
          </div>
          <div className="w-1.5 h-1.5 rounded-full bg-brand-gold/30 shrink-0" data-id="element-179"></div>
          <div className="flex items-center text-[15px]" data-id="element-180">
            <span className="font-bold text-brand-gold mr-2" data-id="element-181">6</span> Tomos
            listos
          </div>
          <div className="w-1.5 h-1.5 rounded-full bg-brand-gold/30 shrink-0" data-id="element-182"></div>
          <div className="flex items-center text-[15px]" data-id="element-183">
            <span className="font-bold text-brand-gold mr-2" data-id="element-184">2</span> Bonus
            incluidos
          </div>
          <div className="w-1.5 h-1.5 rounded-full bg-brand-gold/30 shrink-0" data-id="element-185"></div>
          <div className="flex items-center text-[15px]" data-id="element-186">
            <Star className="w-4 h-4 text-brand-gold fill-brand-gold mr-1" data-id="element-187" />
            4.9/5 calificación
          </div>
        </div>
      </div>
    </div>;
};